import React, { useState, useEffect } from 'react';
import { requestNotificationPermission, checkSubscriptionStatus } from '../utils/pushNotifications';
import './NotificationPrompt.css';

const NotificationPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const checkAndShowPrompt = async () => {
      // Check if user said "never ask again"
      const neverAsk = localStorage.getItem('notificationNeverAsk');
      
      // Don't show if user said "never"
      if (neverAsk === 'true') {
        return;
      }

      // Don't show if user explicitly unsubscribed
      const explicitlyUnsubscribed = localStorage.getItem('pushNotificationUnsubscribed');
      if (explicitlyUnsubscribed === 'true') {
        return;
      }

      // Check if notifications are supported
      if (!('Notification' in window) || !('serviceWorker' in navigator)) {
        return;
      }

      // Don't show if already granted and subscribed
      if (Notification.permission === 'granted') {
        const isSubscribed = await checkSubscriptionStatus();
        if (isSubscribed) {
          return;
        }
      }

      // Don't show if already denied
      if (Notification.permission === 'denied') {
        return;
      }

      // Check if user is already subscribed
      const isSubscribed = await checkSubscriptionStatus();
      if (isSubscribed) {
        return;
      }

      // Show prompt after 3 seconds delay
      setTimeout(() => {
        setShowPrompt(true);
      }, 3000);
    };

    checkAndShowPrompt();
  }, []);

  const handleAllow = async () => {
    try {
      const success = await requestNotificationPermission();
      if (success) {
        // Clear both "never ask" and "unsubscribed" flags
        localStorage.removeItem('notificationNeverAsk');
        localStorage.removeItem('pushNotificationUnsubscribed');
        handleClose();
      } else {
        // If failed, user might have denied, so don't ask again
        localStorage.setItem('notificationNeverAsk', 'true');
        handleClose();
      }
    } catch (error) {
      console.error('[NotificationPrompt] Error:', error);
      handleClose();
    }
  };

  const handleNotNow = () => {
    // Just close the prompt - will show again on next page load
    handleClose();
  };

  const handleNever = () => {
    // Never ask again
    localStorage.setItem('notificationNeverAsk', 'true');
    handleClose();
  };

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowPrompt(false);
      setIsClosing(false);
    }, 300);
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <>
      <div 
        className={`notification-prompt-overlay ${isClosing ? 'fade-out' : ''}`}
        onClick={handleNotNow}
      />
      <div className={`notification-prompt ${isClosing ? 'slide-out' : ''}`}>
        <div className="notification-prompt-icon">
          🔔
        </div>
        <h3 className="notification-prompt-title">
          ताज़ा खबरों की सूचना पाएं
        </h3>
        <p className="notification-prompt-message">
          नई खबरें प्रकाशित होते ही तुरंत सूचना प्राप्त करें। सूचनाएं सक्षम करने के लिए "अनुमति दें" पर क्लिक करें।
        </p>
        <div className="notification-prompt-actions">
          <button 
            className="notification-prompt-btn primary"
            onClick={handleAllow}
          >
            अनुमति दें
          </button>
          <button 
            className="notification-prompt-btn secondary"
            onClick={handleNotNow}
          >
            अभी नहीं
          </button>
        </div>
        <button 
          className="notification-prompt-never"
          onClick={handleNever}
        >
          फिर कभी नहीं पूछें
        </button>
      </div>
    </>
  );
};

export default NotificationPrompt;
